import { useState } from "react";
import { TextField } from "./text-field";
import { IconButton } from "./button";
import { HideEyeIcon, EyeIcon } from "@icons";
import type { TextFieldProps } from "./text-field";

type ShowPasswordProps = Omit<TextFieldProps, `type`>;

export const ShowPassword: React.FC<ShowPasswordProps> = ({ helperText, label, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="show-password">
            <div className="relative">
                <TextField
                    {...props}
                    label={label}
                    type={showPassword ? `text` : `password`}
                />
                <IconButton
                    type="button"
                    variant="tertiary"
                    size="sm"
                    onClick={() => setShowPassword(prev => !prev)}
                    className="absolute top-1/2 -translate-y-1/2 right-3 rounded"
                    aria-label={showPassword ? `Hide password` : `Show password`}
                >
                    {showPassword ? (
                        <HideEyeIcon className="w-4 h-4" aria-hidden />
                    ) : (
                        <EyeIcon className="w-4 h-4" aria-hidden />
                    )}
                </IconButton>
            </div>
            {helperText && !props.error && (
                <p className={label ? `mt-2 text-xs leading-4 text-neutral-700` : `mt-2 px-4 text-xs leading-4 text-neutral-600`}>
                    {helperText}
                </p>
            )}
        </div>
    );
};
